import { makeStyles } from "@material-ui/core";

import HomeIcon from "@material-ui/icons/Home";
import NotificationsIcon from "@material-ui/icons/Notifications";
import WhatshotIcon from "@material-ui/icons/Whatshot";
import AddCircleIcon from "@material-ui/icons/AddCircle";

import { Link } from "react-router-dom";

const Navigation = () => {
  const classes = useStyles();

  return (
    <div className={classes.navigation}>
      <Link to="/allNews/##" className={classes.nav_buttons}>
        <HomeIcon />
        <p>Home</p>
      </Link>
      <Link to="/allNews/#" className={classes.nav_buttons}>
        <NotificationsIcon />
        <p>Alert</p>
      </Link>
      <Link to="/superAdmin/manageAccount" className={classes.nav_buttons}>
        <WhatshotIcon />
        <p>Trending</p>
      </Link>
      <Link to="admin/addNews" className={classes.nav_buttons}>
        <AddCircleIcon variant="contained" />
        <p>Add News</p>
      </Link>
    </div>
  );
};

export default Navigation;

const useStyles = makeStyles((theme) => ({
  navigation: {
    backgroundColor: "#8c0a19",
    borderRadius: "0",
    bottom: "0",
    display: "flex",
    left: "0",
    position: "fixed",
    width: "100%",
    margin: "0",
    justifyContent: "center",
    alignSelf: "center",
    [theme.breakpoints.up("md")]: {
      width: "56%",
      margin: "0 22%",
      borderRadius: ".75rem .75rem 0 0",
    },
  },
  nav_buttons: {
    // backgroundColor: "#dd4",
    cursor: "pointer",
    color: "inherit",
    textDecoration: "none",
    margin: "0",
    width: "100%",
    textAlign: "center",
    alignSelf: "center",
    "& p": {
      margin: 0,
      padding: 0,
    },
    "&:hover": {
      color: "inherit",
      transform: "scale(1.03)",
    },
  },
}));
